export const TEMPLATE_TYPES = {
  CONTENT_TEMPLATE: "CONTENT_TEMPLATE",
  INTAKE_MISSING_INFORMATION: "INTAKE_MISSING_INFORMATION",
  INTAKE_REFERAL_THANK_YOU: "INTAKE_REFERAL_THANK_YOU",
  INTAKE_DISCONTINUE_PROCESSING: "INTAKE_DISCONTINUE_PROCESSING",
  INTAKE_EXPIRED_ORDER: "INTAKE_EXPIRED_ORDER",
  DENIAL_FOLLOW_UP: "DENIAL_FOLLOW_UP",
  APPEAL_COVER_SHEET: "APPEAL_COVER_SHEET",
};

export class ClientTemplate {
  constructor(template) {
    this.id = template.id;
    this.name = template.name;
    this.content = template.content;
    this.contentType = template.contentType;
    this.templateType = template.templateType;
    this.editableContent = template.editableContent;
  }
}
